import Profile from "./Profile/Profile";

function App() {
  return (
    <Profile />
  );
}

export default App;
